import { render } from "./SendSettingsPanel.vue?vue&type=template&id=6a2117c4"
import script from "./SendSettingsPanel.vue?vue&type=script&lang=js"
export * from "./SendSettingsPanel.vue?vue&type=script&lang=js"

import "./SendSettingsPanel.vue?vue&type=style&index=0&id=6a2117c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__